import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"

export const FileAltRegular = (props) => {
  return <FontAwesomeIcon faIcon={faFileAlt} {...props} />
}
